import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter, Youtube } from "lucide-react";
import Logo from "./Logo";

const COLUMNS = [
  { heading: "Explore", links: ["Destinations", "Experiences", "Events", "Stories", "Travel Guide"] },
  { heading: "Company", links: ["About Us", "Careers", "Blog", "Press", "Contact Us"] },
  { heading: "Support", links: ["Help Center", "FAQs", "Privacy Policy", "Terms & Conditions"] },
];

export default function Footer() {
  return (
    <footer className="bg-navy-900 pt-16 text-white/80">
      <div className="container-page grid grid-cols-1 gap-10 pb-12 md:grid-cols-[1.5fr_1fr_1fr_1.2fr]">
        <div>
          <Logo variant="light" />
          <p className="mt-4 max-w-xs text-sm text-white/60">
            Maayad is an AI-powered travel and tourism platform that helps you
            explore India beyond destinations — into stories, culture, and
            unforgettable experiences.
          </p>
          <div className="mt-4 flex gap-3">
            {[Facebook, Instagram, Youtube, Twitter, Linkedin].map((Icon, i) => (
              <a
                key={i}
                href="/#"
                className="grid h-8 w-8 place-items-center rounded-full bg-white/10 text-white/80 transition hover:bg-iris-500 hover:text-white"
              >
                <Icon size={15} />
              </a>
            ))}
          </div>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.heading}>
            <h4 className="mb-4 text-sm font-semibold text-white">{col.heading}</h4>
            <ul className="space-y-2 text-sm">
              {col.links.map((l) => (
                <li key={l}>
                  <a href="/#" className="text-white/60 transition hover:text-gold-400">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <h4 className="mb-4 text-sm font-semibold text-white">Contact</h4>
          <ul className="space-y-3 text-sm text-white/60">
            <li className="flex items-center gap-2"><Phone size={15} className="text-gold-400" /> +91 93528 03541</li>
            <li className="flex items-center gap-2"><Mail size={15} className="text-gold-400" /> hello@maayad.com</li>
            <li className="flex items-center gap-2"><MapPin size={15} className="text-gold-400" /> Udaipur, Rajasthan, India</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <div className="container-page text-center text-xs text-white/50">
          © {new Date().getFullYear()} Maayad. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}
